import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {SPECIAL_SYMBOLS} from "./constants";

const styles = (theme) => ({
  label: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.TextColor,
    opacity: 0.6,
    marginBottom: 4,
  },
  labelText: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.TextColor,
    marginBottom: 4,
  },
  value: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    marginTop: 16,
  },
  shipperDetailRow: {
    display: "flex",
    paddingTop: 4,
    paddingBottom: 4,
    flex: 1,
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  narrowColumn:{
    flex: 4,
  },
  column: {
    flex: 6,
  },
  wideColumn: {
    flex: 25,
  },
  dataNotFound: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    letterSpacing: "0.25px",
    marginTop: 10,
  }
});

const RenderHeaderRow = withStyles(styles)((props) => {
  const {classes} = props;
  return (
    <div className={classes.shipperDetailRow}>
      <div className={classes.column}>
        <span className={classes.label}>PC</span>
      </div>
      <div className={classes.narrowColumn}>
        <span className={classes.label}>H</span>
      </div>
      <div className={classes.column}>
        <span className={classes.label}>PKG</span>
      </div>
      <div className={classes.wideColumn}>
        <span className={classes.label}>DESC</span>
      </div>
      <div className={classes.column}>
        <span className={classes.label}>CL</span>
      </div>
      <div className={classes.column}>
        <span className={classes.label}>WT</span>
      </div>
    </div>
  );
}); 

const RenderRow = withStyles(styles)((props) => {
  const {classes, freightDetails: {
    pieces,
    isHazmat,
    packageCode,
    freightDescription,
    code,
    weight,
  }} = props;
  return (
    <div className={classes.shipperDetailRow}>
      <div className={classes.column}>
        <span className={classes.labelText}>{pieces || null}</span>
      </div>
      <div className={classes.narrowColumn}>
        <span className={classes.labelText}>{isHazmat ? SPECIAL_SYMBOLS.HAZMAT : ''}</span>
      </div>
      <div className={classes.column}>
        <span className={classes.labelText}>{packageCode}</span>
      </div>
      <div className={classes.wideColumn}>
        <span className={classes.labelText}>{freightDescription}</span>
      </div>
      <div className={classes.column}>
        <span className={classes.labelText}>{!isNaN(Number(code)) ? code : null}</span>
      </div>
      <div className={classes.column}>
        <span className={classes.labelText}>{weight || null}</span>
      </div>
    </div>
  );
});

const FreightDescription = ({ classes, freightBillDetails }) => {
  return (
    <>
      <RenderHeaderRow />
      {freightBillDetails ? (
        freightBillDetails?.map((freightDetails) => (
          <RenderRow freightDetails={freightDetails} />
        ))
      ) : (
        <div className={classes.dataNotFound}>Freight details not available</div>
      )}
    </>
  );
};

export default withStyles(styles)(FreightDescription);